$(document).ready(function() {
// Custom function to update the cart
  function updateCartnew(value, isUpdate) {
    const attributes = value;
    $.ajax({
      url: window.ShopifyShop.url +'/cart/update.js',
      // url: 'http://127.0.0.1:9292/cart/update.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ attributes }),
      success: function(data) {
        $('#collection-product-grid-container').removeClass();
        $('#collection-product-grid-container').addClass(attributes.gridView);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error("Error updating cart:", textStatus, errorThrown);
      }
    });
  }

  // Function to initialize grid view
  function initGridViewnew() {
    const collectionProductGridList = $('.grid-list');
    const modeView = collectionProductGridList;

    if (modeView.length) {
      const gridView = collectionProductGridList.find('.grid');
      gridView.on('click', function() {
        const gridClass = $(this).data('grid');
        // collectionProductGridList.removeClass(); // Reset classes
        // collectionProductGridList.addClass(gridClass); // Add new class
        updateCartnew({ gridView: gridClass }, false); // Update cart
      });
    }
  }
  initGridViewnew();
});